import { getLogger, type GqlExecutor } from '@hopdrive/sdk-core'
import { getActionTypeByName } from '@gql/operations'
import type { ActionType } from '../../types'
import { EventKeyNotFoundError } from '../../errors/event-errors'

export async function getActionByName(
  name: string,
  executor?: GqlExecutor
): Promise<ActionType> {
  const result = await getActionTypeByName({ name }, { executor })

  const actiontype = result?.[0]
  if (!actiontype) {
    throw new EventKeyNotFoundError(name)
  }

  getLogger().debug('event.actionTypeLookup', { name, id: actiontype.id })

  return {
    id: actiontype.id as number,
    name: actiontype.name as string,
    expiry: (actiontype.expiry as number) ?? null,
  }
}
